import * as React from "react";

function EnvelopeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M448 64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V128c0-35.35-28.7-64-64-64zM64 112h384c8.822 0 16 7.178 16 16v22.16l-166.8 138.1c-23.19 19.28-59.34 19.27-82.47.016L48 150.2V128c0-8.8 7.18-16 16-16zm384 288H64c-8.822 0-16-7.178-16-16V212.7l136.1 113.4c20.2 16.7 45.7 25.9 71.9 25.9s51.75-9.188 71.97-25.98L464 212.7V384c0 8.8-7.2 16-16 16z"
  }));
}

const ForwardRef = React.forwardRef(EnvelopeIcon);
export default ForwardRef;